<template>
  <div class="traffic_notification">

    <TextTable
        :all_data = "all_data"
    />

  </div>
</template>

<script>
import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'traffic_notification',
  components: {
    TextTable
  },
  data () {
    return {
      all_data: {}
    }
  },
  mounted () {
    this.get_list()
  },
  methods: {
    get_list(){
      this.$http.v1.getTrafficNotification((response) => {
        this.all_data = response.data
      })
    }
  }
}

</script>

<style lang='scss' scoped>
  table{
    font-size: 14px;
    line-height: 120%;
    tbody{
      .emails,
      .filters{
        span{
          display: block;
        }
      }
    }
  }


</style>
